import styled from "styled-components";
import {hexToRgba} from "../../../../themes/hex-to-rgba";


export const TabsNavigationItemContainerDefaultBox = styled.div<{isActive: boolean}>`
    display: flex;
    align-items: center;
    gap: 8px;

    background-color: ${({theme, isActive}) => isActive ? hexToRgba(theme.colors.logoBackground, 0.2) : theme.colors.backgroundMiddleDark};
    border: 1px solid transparent;
    border-color: ${({theme, isActive}) => isActive ? theme.colors.logoBackground : 'transparent'};
    border-radius: 100px;
    font-size: 1.4rem;
    ${({theme, isActive}) => isActive ? theme.font.presets.body : theme.font.presets.medium};
    color: ${({theme, isActive}) => isActive ? theme.colors.textActive : theme.colors.textLight};
    padding: 4px 12px 4px 4px;
    width: max-content;
`;
